"use client";

import { useLocale } from "@/i18n/provider";

/**
 * Print / save-as-PDF trigger for the public terms page.
 *
 * The terms page itself is a server component (statutory text must be in the
 * static HTML, crawler-visible without JS). This one tiny island carries the
 * single bit of interactivity — `window.print()` — without forcing the whole
 * page to hydrate. It hides itself in print output (`print:hidden`) so the
 * button never bleeds into the saved PDF. No PDF generation here by design:
 * the browser's own print-to-PDF is the deliberate, dependency-free path.
 *
 * Rendered inside the page's EnglishMarketingScope, so its label follows the
 * EN/NL toggle like the rest of the document (English by default).
 */
export function PrintTermsButton() {
  const { locale } = useLocale();
  const label = locale === "nl" ? "Print of bewaar als PDF" : "Print or save as PDF";
  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="print:hidden inline-flex items-center gap-2 rounded-full border border-line-subtle bg-bg-elev/40 px-4 py-1.5 text-[12px] font-medium text-fg-dim hover:text-fg hover:border-line transition-colors"
    >
      {label}
    </button>
  );
}
